import { render, staticRenderFns } from "./FunnelChart6.vue?vue&type=template&id=6bfbc895&scoped=true&"
import script from "./FunnelChart6.vue?vue&type=script&lang=js&"
export * from "./FunnelChart6.vue?vue&type=script&lang=js&"
import style0 from "./FunnelChart6.vue?vue&type=style&index=0&id=6bfbc895&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfbc895",
  null
  
)

export default component.exports